const TopBar = () => {
  return null;
};

export default TopBar;
